/* eslint-disable */
// English
export default {
  nav: {
    home: 'Home',
    wall: 'The Wall',
    chat: 'Messages',
    groups: 'Groups',
    users: 'Users',
    friends: 'Friends',
    profile: 'My Profile',
    help: 'Help',
    membership: 'Membership',
    logout: 'Log out',
    login: 'Log in',
    blog: 'Blog'
  },
  auth: {
    loginSubtitle: 'Sign in to continue',
    email: 'Email',
    password: 'Password',
    noAccount: "Don't have an account?",
    createAccount: 'Create account',
    loginFailed: 'Login failed. Check your email and password.',
    alreadyHaveAccount: 'Already have an account?',
    register: 'Register',
    name: 'Name',
    confirmPassword: 'Confirm password',
    registrationSuccess: 'Account created! You can now log in.',
    registrationFailed: 'Could not create account.'
  },
  home: {
    title: 'Community',
    tagline: 'A calm place online – without ads.',
    description: 'Share everyday life with family, friends and new acquaintances. No noise, no tracking, no data selling.',
    features: {
      noAds: 'Ad-free',
      simple: 'Simple and clear',
      safe: 'Safe tone + moderation'
    },
    cta: {
      openWall: 'Open the Wall',
      createProfile: 'Create free profile',
      goToWall: 'Go to the Wall',
      readMore: 'Read about the idea'
    },
    pricing: 'The site is free to use.',
    pricingDetail: 'But servers and bandwidth cost money – please consider donating to keep the site alive.'
  },
  wall: {
    title: 'The Wall',
    subtitle: 'Here you see posts from the community.',
    writePost: 'WRITE ON THE WALL',
    placeholder: 'Write your post here...',
    group: 'Group',
    noGroup: 'No group',
    selectImage: 'Select image',
    selectImages: 'Select images',
    imageHint: 'Max {max} images, {size}MB each',
    imagesSelected: '{count} images selected',
    noFileSelected: 'No file selected.',
    send: 'Post',
    public: 'Public',
    newPosts: '{count} new post | {count} new posts',
    members: 'Members',
    private: 'Private',
    visibility: 'Visibility'
  },
  groups: {
    title: 'Groups',
    subtitle: 'Groups that make sense – local, hobbies, travel, walks – easy to follow.',
    createGroup: 'Create group',
    allGroups: 'All groups',
    myGroups: 'My groups',
    searchPlaceholder: 'Search groups...',
    noGroups: 'No groups found',
    noMyGroups: 'You are not a member of any groups yet',
    groupName: 'Group name',
    description: 'Description',
    publicGroup: 'Public group (everyone can see and join)',
    private: 'Private',
    privateGroup: 'Private Group',
    privateGroupMessage: 'This is a private group. You need an invitation to join.',
    notFound: 'Group Not Found',
    notFoundMessage: 'This group does not exist or has been deleted.',
    backToGroups: 'Back to Groups',
    createdBy: 'Created by',
    members: 'members',
    postsCount: 'posts',
    noDescription: 'No description',
    join: 'Join',
    leave: 'Leave',
    open: 'Open',
    leaveConfirm: 'Are you sure you want to leave this group?',
    postsTab: 'Posts',
    membersTab: 'Members',
    invitesTab: 'Invites',
    noPosts: 'No posts in this group yet',
    newPost: 'New post',
    joinToSee: 'Join the group to see posts',
    about: 'About',
    createdOn: 'Created',
    editGroup: 'Edit group',
    deleteConfirm: 'Are you sure you want to delete this group? All posts will be deleted.',
    setMember: 'Set as member',
    setModerator: 'Set as moderator',
    setAdmin: 'Set as admin',
    removeMember: 'Remove from group',
    removeMemberConfirm: 'Are you sure you want to remove {name} from the group?',
    changeCover: 'Change cover image',
    invalidImageType: 'Invalid file type. Please select an image.',
    imageTooLarge: 'Image is too large. Maximum 5MB.',
    inviteMembers: 'Invite Members',
    inviteMember: 'Invite',
    searchUsers: 'Search users to invite...',
    pendingInvites: 'Pending Invites',
    noInvites: 'No pending invites',
    inviteSent: 'Invite sent!',
    cancelInvite: 'Cancel invite',
    invitedBy: 'Invited by',
    acceptInvite: 'Accept',
    declineInvite: 'Decline',
    youHaveInvite: 'You have been invited to this group',
    visibleInFeed: 'Visible in feed',
    hiddenFromFeed: 'Hidden from feed',
    member: 'Member',
    showAll: 'Show all in feed',
    hideAll: 'Hide all from feed',
    joinToComment: 'Join the group to comment',
  },
  blog: {
    title: 'The Blog',
    allCategories: 'All categories',
    search: 'Search the blog...',
    newest: 'Newest',
    popular: 'Popular',
    writePost: 'Write post',
    noPosts: 'No blog posts yet. Be the first to write!',
    loadMore: 'Show more',
    backToBlog: 'Back to blog',
    comments: 'Comments',
    noComments: 'No comments yet. Start the debate!',
    writeComment: 'Write a comment...',
    writeReply: 'Write a reply...',
    comment: 'Comment',
    reply: 'Reply',
    quote: 'Quote',
    edit: 'Edit',
    delete: 'Delete',
    report: 'Report',
    reportComment: 'Report comment',
    flagDetails: 'Describe the issue...',
    showReplies: 'Show {count} replies',
    hideReplies: 'Hide replies',
    reactionsTotal: 'reactions',
    editPost: 'Edit post',
    headerImage: 'Header image (URL)',
    category: 'Category',
    postTitle: 'Title',
    postBody: 'Content',
    markdownHint: 'Use **bold** and *italic*. @username to mention someone.',
    publish: 'Publish',
    update: 'Update',
    postNotFound: 'Blog post not found',
    upload: 'Upload',
    linkUrl: 'Link (URL)',
    chooseImage: 'Choose an image...',
    imageLoadError: 'Image could not be loaded',
    categoryRequired: 'Choose a category',
    titleMinLength: 'At least 5 characters',
    characters: 'characters',
    minCharacters: 'At least {min} characters required',
    commentMinLength: 'Comment must be at least 2 characters',
    commentUpdateFailed: 'Failed to update comment',
    commentDeleteFailed: 'Failed to delete comment',
    categories: {
      politik: 'Politics',
      videnskab: 'Science',
      sport: 'Sports',
      rejser: 'Travel',
      gaming: 'Gaming',
      mad: 'Food',
      klima: 'Climate',
      sundhed: 'Health',
      uddannelse: 'Education',
      teknologi: 'Technology',
      kultur: 'Culture',
      okonomi: 'Economy'
    },
    linkCopied: "Link copied!",
    copyLink: "Copy link"
  },
  profile: {
    title: 'My Profile',
    editProfile: 'Edit profile',
    myPosts: 'My posts',
    myGroups: 'My groups',
    overview: 'Overview',
    edit: 'Edit',
    settings: 'Settings',
    activity: 'Activity',
    bio: 'About me',
    location: 'Location',
    website: 'Website',
    birthday: 'Birthday',
    interests: 'Interests',
    joined: 'Joined',
    posts: 'Posts',
    comments: 'Comments',
    reactions: 'Reactions',
    privacy: 'Privacy',
    showRealName: 'Show real name publicly',
    showEmail: 'Show email publicly',
    emailNotifications: 'Email notifications',
    showOnlineStatus: 'Show online status',
    showOnlineStatusHint: 'When disabled, you appear offline to others (incognito mode)',
    onlineStatus: 'Online status',
    online: 'Online',
    away: 'Away',
    offline: 'Offline',
    lastSeen: 'Last seen',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    uploadAvatar: 'Upload profile picture',
    changeAvatar: 'Change profile picture',
    removeAvatar: 'Remove profile picture',
    bioPlaceholder: 'Tell us about yourself...',
    interestsPlaceholder: 'What are you interested in?',
    saveChanges: 'Save changes',
    cancelChanges: 'Cancel',
    profileUpdated: 'Profile updated!',
    passwordChanged: 'Password changed!',
    avatarUploaded: 'Profile picture uploaded!',
    recentPosts: 'Recent posts',
    recentComments: 'Recent comments',
    recentReactions: 'Recent reactions',
    noPosts: 'No posts yet',
    noComments: 'No comments yet',
    noReactions: 'No reactions yet',
    downloadData: 'Download my data',
    deleteAccount: 'Delete account',
    deleteAccountWarning: 'This will permanently delete your account and all data. This action cannot be undone.',
    age: 'years old'
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success!',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    post: 'Post',
    comment: 'Comment',
    quote: 'Quote',
    reply: 'Reply',
    confirm: 'Confirm',
    ok: 'OK',
    data: 'Data',
    viewAll: 'View all',
    noComments: 'No comments yet. Be the first!',
    writeComment: 'Write a comment...',
    replyToComment: 'Reply to comment...',
    deleteConfirm: 'Delete this post?',
    contentRequired: 'Content cannot be empty',
    updateFailed: 'Failed to update post',
    deleteFailed: 'Failed to delete post',
    commentFailed: 'Failed to post comment'
  },
  users: {
    searchTitle: 'Find Users',
    searchSubtitle: 'Search for users in the community',
    searchSubtitleWithCount: 'Search among our {count} users',
    searchPlaceholder: 'Search by username, name or email...',
    search: 'Search',
    searchHint: 'Enter at least 2 characters to search for users',
    resultsFound: '{count} user(s) found',
    noResults: 'No users found. Try a different search term.',
    noUsers: 'No users yet',
    memberSince: 'Member since',
    showing: 'Showing {from}-{to} of {total}',
    you: 'You'
  },
  friends: {
    title: 'Friends',
    subtitle: 'Stay connected with your friends',
    myFriends: 'My Friends',
    requests: 'Requests',
    sent: 'Sent',
    findFriends: 'Find Friends',
    noFriends: 'You have no friends yet. Find someone to connect with!',
    noRequests: 'No pending friend requests',
    noSentRequests: 'You have not sent any friend requests',
    addFriend: 'Add Friend',
    removeFriend: 'Remove Friend',
    remove: 'Remove',
    removeConfirm: 'Are you sure you want to remove {name} as a friend?',
    accept: 'Accept',
    decline: 'Decline',
    cancel: 'Cancel',
    friends: 'Friends',
    unfriend: 'Unfriend',
    requestSent: 'Request Sent',
    sentOn: 'Sent'
  },
  chat: {
    title: 'Messages',
    searchConversations: 'Search conversations...',
    noConversations: 'No conversations yet',
    noMessages: 'No messages yet',
    selectConversation: 'Select a conversation to start chatting',
    startNewChat: 'Start New Chat',
    searchUsers: 'Search users...',
    start: 'Start',
    typeMessage: 'Type a message...',
    you: 'You',
    image: 'Image',
    file: 'File',
    today: 'Today',
    yesterday: 'Yesterday',
    typing: 'Typing...',
    edited: 'edited',
    editHistory: 'Edit History',
    editingMessage: 'Editing message',
    deleteConfirm: 'Delete this message?',
    messageDeleted: 'Message deleted',
    loadMore: 'Load more',
    fileTooLarge: 'File too large. Maximum 2MB.',
    uploadFailed: 'Failed to upload file',
    viewProfile: 'View Profile',
    sendMessage: 'Send Message',
    videoCall: 'Video call',
    joinCall: 'Join',
    calling: 'Calling...',
    connecting: 'Connecting...'
  },
  accessibility: {
    title: 'Settings',
    colorTheme: 'Color Theme',
    fontSize: 'Font Size',
    fontSizeHint: 'Adjust text size for easier reading',
    highContrast: 'High Contrast',
    highContrastHint: 'Increase contrast for better visibility',
    textToSpeech: 'Read Aloud',
    textToSpeechHint: 'Have text read out loud',
    testSpeech: 'Test Speech',
    testMessage: 'Hello! Text to speech is working.',
    reset: 'Reset',
    readAloud: 'Read aloud',
    translateTo: 'Translate posts to',
    translateHint: 'Automatically show translate button on posts and comments',
    noTranslate: 'No translation',
    translate: 'Translate',
    showOriginal: 'Original',
    favoriteGroup: 'Favorite Group',
    favoriteGroupHint: 'Select a group to be shown by default on the wall',
    noFavoriteGroup: 'No favorite group',
    readerMode: 'Reader Mode',
    readerModeHint: 'Show a button that opens posts in fullscreen with large text',
    fontIncrease: 'Larger text',
    fontDecrease: 'Smaller text',
    prevPost: 'Previous',
    nextPost: 'Next',
    wrote: 'wrote',
  },
  pages: {
    lastUpdated: 'Last updated',
    notFound: 'Page not found',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Find answers to common questions',
    searchFaq: 'Search FAQ...',
    noFaqResults: 'No results found',
    stillNeedHelp: 'Still need help?',
    contactUs: 'Contact us and we will get back to you as soon as possible.',
    sendEmail: 'Send Email'
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to the most common questions.',
    empty: 'No FAQs available yet.',
    categories: {
      account: 'Account',
      groups: 'Groups',
      chat: 'Messages',
      privacy: 'Privacy',
      settings: 'Settings',
      general: 'General'
    }
  },
  footer: {
    about: 'About Us',
    terms: 'Terms',
    privacy: 'Privacy',
    faq: 'FAQ'
  },
  admin: {
    title: 'Administration',
    subtitle: 'Manage users, content and settings',
    accessDenied: 'Access denied. You must be an administrator.',
    users: 'Users',
    posts: 'Posts',
    groups: 'Groups',
    pages: 'Pages',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    totalPosts: 'Total Posts',
    totalGroups: 'Total Groups',
    searchUsers: 'Search users...',
    searchPosts: 'Search posts...',
    filterByStatus: 'Filter by status',
    filterByGroup: 'Filter by group',
    user: 'User',
    email: 'Email',
    status: 'Status',
    role: 'Role',
    joined: 'Joined',
    actions: 'Actions',
    member: 'Member',
    viewProfile: 'View profile',
    activate: 'Activate',
    deactivate: 'Deactivate',
    block: 'Block',
    makeAdmin: 'Make admin',
    removeAdmin: 'Remove admin',
    statusLabels: {
      active: 'Active',
      inactive: 'Inactive',
      blocked: 'Blocked'
    },
    allGroups: 'All groups',
    images: 'images',
    comments: 'comments',
    reactions: 'reactions',
    noPosts: 'No posts found',
    deletePost: 'Delete post',
    deletePostConfirm: 'Are you sure you want to delete this post? This cannot be undone.',
    reason: 'Reason (optional)',
    groupName: 'Group name',
    type: 'Type',
    creator: 'Creator',
    members: 'Members',
    created: 'Created',
    public: 'Public',
    private: 'Private',
    noGroups: 'No groups found',
    createPage: 'Create page',
    editPage: 'Edit page',
    slug: 'Slug',
    locale: 'Locale',
    pageTitle: 'Title',
    content: 'Content',
    metaDescription: 'Meta description',
    published: 'Published',
    draft: 'Draft',
    lastUpdated: 'Last updated',
    deletePage: 'Delete page',
    deletePageConfirm: 'Are you sure you want to delete the page "{title}"?',
    // FAQ
    createFaq: 'Create FAQ',
    editFaq: 'Edit FAQ',
    deleteFaq: 'Delete FAQ',
    deleteFaqConfirm: 'Are you sure you want to delete this question?',
    faqCategory: 'Category',
    faqCategoryHint: 'Select existing or type new',
    faqQuestion: 'Question',
    faqAnswer: 'Answer',
    faqUncategorized: 'Uncategorized',
    noFaqs: 'No FAQs yet',
    noFaqsHint: 'Create your first FAQ question above.',
    sortOrder: 'Sort order',
  },
  kanban: {
    newTask: 'New task',
    editTask: 'Edit task',
    deleteTask: 'Delete task',
    deleteConfirm: 'Are you sure you want to delete this task?',
    title: 'Title',
    description: 'Description',
    status: 'Status',
    priority: 'Priority',
    assignee: 'Assignee',
    dueDate: 'Due date',
    columns: {
      ideas: 'Ideas',
      todo: 'ToDo',
      inProgress: 'In Progress',
      test: 'Test',
      done: 'Done'
    },
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent'
    },
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday'
  },
  validation: {
    required: 'This field is required',
    email: 'Enter a valid email',
    maxLength: 'Max {max} characters',
    passwordMatch: 'Passwords must match',
    maxFiles: 'Max {max} files',
    maxFileSize: 'Files must be under {max}'
  },
  poll: {
    poll: 'Poll',
    pollVoted: 'Poll · you voted',
    singleChoice: 'Single choice',
    multipleChoice: 'Multiple choice',
    yesNo: 'Yes / No',
    yes: 'Yes',
    no: 'No',
    votes: '{count} votes',
    voteNoun: 'votes',
    daysLeft: 'Closes in {count}d',
    hoursLeft: 'Closes in {count}h',
    minsLeft: 'Closes in {count}m',
    closingSoon: 'Closing soon',
    closed: 'Closed',
    castYourVote: 'Cast your vote',
    submitVote: 'Submit vote',
    changeVote: 'Change vote',
    addPoll: 'Add poll',
    removePoll: 'Remove poll',
    type: 'Poll type',
    question: 'Ask a question…',
    options: 'Options',
    option: 'Option',
    addOption: 'Add option',
    expiresAt: 'Close poll on (optional)'
  }
}